import { render, staticRenderFns } from "./edit-entity-project-rules-modal.vue?vue&type=template&id=6637ea8a"
import script from "./edit-entity-project-rules-modal.vue?vue&type=script&lang=js"
export * from "./edit-entity-project-rules-modal.vue?vue&type=script&lang=js"
import style0 from "./edit-entity-project-rules-modal.vue?vue&type=style&index=0&id=6637ea8a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports